import { Component } from "react";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import iValue from "../../../../assets/images/svg/iValue.svg";
import cValue from "../../../../assets/images/svg/cValue.svg";
import moment from "moment";

export default class InvestmentValueChart extends Component {
  constructor(props) {
    super(props);
    const data = AnalyticsStore.overall.investmentCategories;
    this.state = {
      options: {
        colors: ["#034DA2", "#C59331"],
        fill: {
          gradient: {
            shadeIntensity: 1,
            stops: [0, 90, 100],
          },
          colors: ["#FFFFFF", "#C59331"],
          opacity: [0.5, 1.0],
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          onItemClick: {
            toggleDataSeries: false,
          },
        },
        chart: {
          height: 350,
          type: "area",
        },
        stroke: {
          curve: "smooth",
          colors: ["#034DA2", "#C59331"],
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        markers: {
        },
        yaxis: {
          enabled: false,
          show: false,
          categories: data,
          crosshairs: {
            show: false,
          },
        },
        xaxis: {
          type: "text",
          categories: data,
          tooltip: {
            enabled: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            offsetX: 8,
            trim: false,
            rotateAlways: false,
            formatter: function (value) {
              if (
                (value && value.includes("Jan")) ||
                (value && value.includes("Apr")) ||
                (value && value.includes("Jul")) ||
                (value && value.includes("Oct"))
              ) {
                return moment(value).format("MMM YY");
              }
            },
            style: {
              colors: "#7E8899",
              fontFamily: "Encode Sans",
              fontSize: "13px",
            },
          },
          crosshairs: {
            show: false,
          },
        },
        tooltip: {
          custom: function ({ value, series, seriesIndex, dataPointIndex, w }) {
            let xValue = series[0][dataPointIndex];
            let yValue = series[1][dataPointIndex];
            let date = w.config.yaxis[0].categories[dataPointIndex];
            return `<div style="padding: 10px; min-width:120px;">
              <div>
                <p style="color: #7E8899; font-size: 14px; font-family: "Encode Sans"">${date}</p>
              <div>
              <div style="margin-top: 8px; display: flex">
                <img src=${iValue} />
                <p class="investment_text">${xValue}</p><span class="currency_value_invest">&nbsp;Cr</span>
              </div>
              <div style="margin-top: 8px; display: flex">
                <img src=${cValue} />
                <p class="current_text">${yValue}</p><span class="currency_value_current">&nbsp;Cr</span>
              </div> 
            </div>`;
          },
        },
      },
    };
  }
}
